import { Component } from '@angular/core';
import { IAMServiceService } from '../service/iamservice.service';
import { UserModel } from '../interface/user-model';
import { SessionModel } from '../interface/session-model';
import { LoaderService } from 'src/app/service/loader.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { URLEnum } from '../url-enum';
import { DatasharingService } from '../service/datasharing.service';
import { AppconfigService } from 'src/app/service/appconfig.service';
import { GlobalService } from 'src/app/service/global.service';



declare var $: any;
declare var jquery: any;



@Component({
  selector: 'app-ext-authentication',

  // imports: [],

  templateUrl: './ext-authentication.component.html',
  styleUrls: ['./ext-authentication.component.scss'],
})
export class ExtAuthenticationComponent {
  userInfo!: UserModel;
  sessionList: SessionModel = new SessionModel();
  loader: boolean = true;
  showLogoutScreen = this.configService.config.showLogoutScreen;
  SessionList: SessionModel = new SessionModel();

  constructor(
    private IAMServiceService: IAMServiceService,
    public LoaderService: LoaderService,
    private router: Router,
    private datasharing: DatasharingService,
    private configService: AppconfigService,
    public globalService: GlobalService,

  ) {

    console.log("Ext Auth constructor ")

  }
  ngOnInit() {
    console.log("Ext Auth")
   
    this.extAuthentication()
  }
 
  public extAuthentication() {

    this.IAMServiceService.ExtAuthentication()
      .subscribe(
        (response) => {
          if (response.status == 'Success') {

            this.userInfo = response.responseData as UserModel;
            let user = response.responseData;
            this.datasharing.userDetails.next(user)
            
            if (this.userInfo.authenticated) {
              this.sessionList.Username = this.userInfo.user_name;

              var date = new Date(this.userInfo.last_login_time);
              this.sessionList.TenantID = this.userInfo.tenant_id;
              this.sessionList.PsdStatus = this.userInfo.password_status;
              this.sessionList.FirstName = this.userInfo.first_name;
              this.sessionList.TenentName = this.userInfo.tenant;
              this.sessionList.Saml = 'true';


              // this.acceptance();
              // if (this.userInfo.authentication_factor != undefined) {
              //   if (this.userInfo.authentication_factor.toLocaleLowerCase() == 'two') {
              //     this.sessionList.authfactor = this.userInfo.authentication_factor
              //     if (this.userInfo.Second_factor_auth_type != undefined) {
              //       // if(this.userInfo.Second_factor_auth_type.toLocaleLowerCase()){
              //       //   this.sessionList.factortype=this.userInfo.Second_factor_auth_type
              //       //   this.router.navigateByUrl(URLEnum.module+URLEnum.secondauth)
              //       // }
              //       // else if(this.userInfo.Second_factor_auth_type.toLocaleLowerCase()){
              //       //   this.sessionList.factortype=this.userInfo.Second_factor_auth_type
              //       // }

              //       if (this.userInfo.Second_factor_auth_type.toLocaleLowerCase() == 'otp') {
              //         this.sessionList.factortype = this.userInfo.Second_factor_auth_type
              //         // this.router.navigateByUrl(URLEnum.module + URLEnum.secondauth)
              //         this.normalLoginFlow = true;
              //         this.switchForms('otpVer');
              //       }
              //       else if (this.userInfo.Second_factor_auth_type.toLocaleLowerCase() == 'secretquestion') {
              //         this.sessionList.factortype = this.userInfo.Second_factor_auth_type
              //         // this.router.navigateByUrl(URLEnum.module + URLEnum.secondauth)
              //         this.normalLoginFlow = true;
              //         this.switchForms('sQ1');
              //         this.getSecretQuestions();

              //       }

              //     }
              //   }
              // }
              // else {
              this.redirectToHomePageOnLoginSuccess();
              // }
            }
            else {

              $('#loader').hide();
              // sessionStorage.clear();
              this.sessionList.errorMsg = response.statusMessage;
              this.router.navigateByUrl(URLEnum.errorscreenComponent);

            }
          }
          else {
            $('#loader').hide();
            this.sessionList.errorMsg = response.statusMessage;
            this.router.navigateByUrl(URLEnum.errorscreenComponent);
          }
        },

        () => {
          $('#loader').hide();
          console.log('ExtAuthentication completed');
        });
  }

  private redirectToHomePageOnLoginSuccess() {
    /*
    *  Authentication has been successful. So load user roles, get menus, home menu 
       Redirect to home page as per menu
       Set first role as default selected role
    */
    this.LoaderService.setLoading(true);
    this.loader = false;
    this.IAMServiceService.getUserRoles().subscribe(
      Data => {
        this.LoaderService.setLoading(false);
        this.loader = true;
        if (Data.status.toLowerCase() == 'success') {
          if (Data.responseData != undefined) {
            let roles = Data.responseData.roles;

            if (roles != undefined && roles.length > 0) {
              this.datasharing.roles.next(roles);

              this.IAMServiceService.getMenuDetails(roles[0]?.name).subscribe(menuData => {
                if (menuData.status.toLowerCase() == 'success') {
                  if (menuData.responseData != undefined) {
                    let menuItems = menuData.responseData.menu;
                    console.log('------------');
                    
                    //Get home menu and redirect
                    //To do.. iterate child menu as well for finding home page
                    menuItems.forEach((menu: any) => {
                      if (menu.is_home == true) {
                        console.log('Inside If');
                        this.datasharing.menuItems.next(menuItems);
                        this.datasharing.selectedRoleB.next(roles[0]?.name);
                        this.sessionList.selectedRole = roles[0]?.name;

                        console.log('Before redirct to home');
                        this.sessionList.homePage = menu.menu_route;
                        this.router.navigateByUrl(menu.menu_route);

                        console.log('After redirct to home');
                      }
                    });
                  }
                }
              });
            }
            else {
              this.sessionList.errorMsg = this.configService.config.noAccessApp;
              this.router.navigateByUrl(URLEnum.errorscreenComponent);
            }
          }
          //To do -- redirect to error page if no roles assigned
        }
        else {
          this.globalService.setErrorMessage(Data.statusMessage);
          this.router.navigateByUrl('/error');
        }
      })

  }

}
